<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/app-banner/table"
          >banner列表</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <span slot="header">表单</span>
      <el-form
        ref="form"
        :model="form"
        :rules="formRules"
        size="medium"
        label-width="140px"
        @submit.native.prevent="onSubmit()"
      >
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="上架APP" prop="app_types">
              <el-checkbox-group v-model="form.app_types">
                <el-checkbox
                  v-for="item in appTypeList"
                  :key="item.value"
                  :label="item.value"
                >{{ item.label }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="图片链接" prop="url">
              <el-input v-model="form.url"></el-input>
            </el-form-item>
            <el-form-item label="优先级" prop="priority">
              <el-input v-model="form.priority"></el-input>
            </el-form-item>
            <el-form-item label="上下架时间" prop="daterange">
              <el-date-picker
                v-model="form.daterange"
                style="width: 100%;"
                type="datetimerange"
                range-separator="至"
                start-placeholder="上架时间"
                end-placeholder="下架日期"
                :default-time="['00:00:00', '23:59:59']"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="图片" prop="img">
              <div>
                <el-upload
                  ref="upload"
                  class="avatar-uploader"
                  :auto-upload="false"
                  action=""
                  :show-file-list="false"
                  :on-change="onChangeFile"
                  :on-remove="handleRemove">
                  <img v-if="form.img" :src="form.img" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <p class="banner-img-hint">建议尺寸：1372*500，大小不超过2M</p>
              </div>
            </el-form-item>
          </div>
        </div>
        <el-form-item>
          <el-button type="primary" native-type="submit">{{id ? '修改' : '添加'}}</el-button>
          <el-button @click="$router.back()">返回</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
  </div>
</template>

<script>
import { formRules } from '../app-banner.rules.js'

export default {
  components: {},
  data () {
    return {
      id: 0,
      formRules,
      form: {
        app_types: [1],
        img: '',
        url: '',
        priority: null,
        upshelftime: '',
        downshelftime: '',
        daterange: []
      }
    }
  },
  computed: Vuex.mapState({
    appTypeList: state => (state.order && state.order.options && state.order.options.app_type_list) || [],
  }),
  watch: {},
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {},
  mounted () {},
  methods: {
    onLoad () {
      if (this.$route.params.id) {
        this.setForm((this.id = this.$route.params.id))
      }
    },
    onReload () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.onLoad()
    },
    allowedAppTypeValues () {
      return this.appTypeList.map(item => Number(item.value))
    },
    setForm (id) {
      request.page('getAppBannerDetail', { id }).then(({ data }) => {
        data.daterange = [data.upshelftime, data.downshelftime]
        data.app_types = this.parseAppTypes(data.app_types)
        filter.setLoop(this.form, data)
      })
    },
    parseAppTypes (raw) {
      const allowed = this.allowedAppTypeValues()
      const fallback = allowed.length ? [allowed[0]] : [1]
      if (raw === undefined || raw === null || raw === '') {
        return fallback
      }
      // 接口返回逗号串；表单 checkbox-group 使用 number[]
      const types = String(raw)
        .split(',')
        .map(s => Number(String(s).trim()))
        .filter(v => allowed.indexOf(v) !== -1)
      return types.length ? types : fallback
    },
    getForm () {
      const form = filter.copyJson(this.form)
      form.upshelftime = form.daterange[0]
      form.downshelftime = form.daterange[1]
      const allowed = this.allowedAppTypeValues()
      const types = (form.app_types || [])
        .map(Number)
        .filter(v => allowed.indexOf(v) !== -1)
      types.sort((a, b) => a - b)
      // 提交给 Core 的 app_types 固定为逗号串
      form.app_types = types.join(',')
      return form
    },
    onSubmit () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.id ? this.update(this.id) : this.create()
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    create () {
      request.common('createAppBannerData', this.getForm()).then(res => {
        this.$confirm(this.$route.meta.title + '成功, 是否继续添加？', '提示', {
          type: 'success'
        }).then(
          () => {
            this.$refs.form.resetFields()
          },
          () => {
            this.$router.push({ path: '/app-banner/table/' })
          }
        )
      })
    },
    update (id) {
      request
        .common('updateAppBannerData', { id, ...this.getForm() })
        .then(res => {
          this.$confirm(
            this.$route.meta.title + '成功, 是否前往列表页面？',
            '提示',
            { type: 'success' }
          ).then(() => {
            this.$router.push({ path: '/app-banner/table/' })
          })
        })
    },
    handleRemove (file, fileList) {
      this.form.img = ''
    },
    onChangeFile (file, fileList) {
      let isExcel = ((file.raw.type === 'image/jpeg') || (file.raw.type === 'image/png'))
      let isLt2M = file.raw.size / 1024 / 1024 < 2
      if (!isExcel) {
        this.$message.error('请上传jpg/jpeg/png图片!')
        this.$refs.upload.clearFiles()
        return false
      }
      if (!isLt2M) {
        this.$message.error('大小不能超过2MB!')
        this.$refs.upload.clearFiles()
        return false
      }
      this.OnUploadFile(file.raw)
    },
    OnUploadFile (file) {
      let formData = new FormData()
      formData.append('file', file)
      return request.common('uploadAppBanner', formData).then(({data}) => {
        this.form.img = data
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
      })
    },
  }
}
</script>
<style lang="scss">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
  object-fit: cover;
}
// 全局CSS
</style>
<style lang="scss" scoped>
.banner-img-hint {
  margin: 8px 0 0;
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}
</style>
<style lang="scss" module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/app-banner/pages/AppBannerForm.vue